import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import {
  ETAT_COMMANDE,
  ETAT_ENREGISTRE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  REGROUPEMENT,
  TYPE_DEVIS,
  ETAT_COMMANDE_PARTIELLEMENT,
  ETAT_BROUILLON,
} from '@/configuration/devisConf';
import { VENTE } from '@/configuration/parametrage/schemaComptableConf';

export default function critereRechercheBaseRelanceOption(criteresRecherche) {
  criteresRecherche.typesProduits = [CATEGORIE_REGROUPEMENT];
  criteresRecherche.etatsDevisCommandeFacture = [
    ETAT_ENREGISTRE,
    ETAT_FACTURE,
    ETAT_FACTURE_PARTIELLEMENT,
    ETAT_COMMANDE,
    ETAT_COMMANDE_PARTIELLEMENT,
    ETAT_BROUILLON,
  ];
  criteresRecherche.typesDevisCommandeFacture = [TYPE_DEVIS];
  criteresRecherche.sens = VENTE;
  criteresRecherche.dateVisualisation = null;
  criteresRecherche.types = [REGROUPEMENT];
}
